import toast from "@/utils/toast";

export default {
  install(Vue) {
    Vue.prototype.$toast = toast;
  }
};
